import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {HttpClient} from '@angular/common/http';
import {Router} from '@angular/router';
import {GridService} from 'app/core-ui/abstract/basegrid/grid.service';
import {ConfigService} from 'app/core-ui/abstract/services/config.service';
import {EventsEmitterService} from 'app/core-ui/abstract/services/emitter.service';
import {LogService} from 'app/core-ui/abstract/services/log.service';
import {catchError, map} from 'rxjs/operators';

@Injectable()
export class DemandApprovalRequestService extends GridService {
  constructor(
    http: HttpClient,
    configService: ConfigService,
    eventsEmitterService: EventsEmitterService,
    router: Router,
    logger: LogService,
  ) {
    super(
      http,
      configService,
      eventsEmitterService,
      router,
      logger,
      'DemandApprovalRequestService',
    );
  }

  getPKs(params: any): Observable<any> {
    let serviceUrl = this.baseUrl + this.serviceName + '/getPKs?' + this.urlParamsToString(params);
    return this.request(serviceUrl).pipe(map(super.extractData), catchError(super.handleError));
  }

  approve(params: any): Observable<any> {
    let serviceUrl = this.baseUrl + this.serviceName + '/approve?';
    return this.request(serviceUrl, this.setPostParams(params)).pipe(catchError(super.handleError));
  }

  reject(params: any): Observable<any> {
    let serviceUrl = this.baseUrl + this.serviceName + '/reject?';
    return this.request(serviceUrl, this.setPostParams(params)).pipe(catchError(super.handleError));
  }
}
